import { ASSET_URL } from '@/config.js'

// virtualsky.js ends with `})(S);` — it needs stuquery.js (which defines the
// global `S`) to have run first. Both used to be added as independent async
// scripts on every page, so whichever arrived first ran first and now and
// then virtualsky threw "S is not defined". Only the Star Map layer uses
// them, so they're loaded here on demand, one after the other, once.
let loading = null

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    script.onerror = () => reject(new Error('Failed to load ' + src))
    document.head.appendChild(script)
  })
}

export const isVirtualSkyReady = () =>
  typeof window.S === 'function' && typeof window.S.virtualsky === 'function'

export const loadVirtualSky = () => {
  if (isVirtualSkyReady()) {
    return Promise.resolve()
  }
  if (!loading) {
    loading = loadScript(ASSET_URL + '/app/virtualskyjs/stuquery.js')
      .then(() => loadScript(ASSET_URL + '/app/virtualskyjs/virtualsky.js'))
      .catch(err => {
        // Let the next call try again (e.g. a network blip).
        loading = null
        throw err
      })
  }
  return loading
}



// WEBPACK FOOTER //
// ./src/helper/virtualSky.js